module.exports = __webpack_public_path__ + "img/security.66654e57.svg";